import React from 'react'
import { useNavigate } from 'react-router-dom'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { CompanyTag } from '@/components/ui/badge'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Body1 } from '@/components/ui/typography'
import { TicketDetailsDto } from 'api/Tickets/Types/TicketDetails'
import { useTabNavigate } from 'hooks/useTabNavigate'

import { generateTicketRouteByViewType } from '../TicketsViewType'

interface Props {
  data: TicketDetailsDto
  tab: TicketTab
}

export enum TicketTab {
  DETAILS = 'details',
}

export const TicketsNavigation: React.FC<Props> = (props) => {
  const { data } = props
  const navigate = useNavigate()
  const tabNavigate = useTabNavigate()

  return (
    <div>
      <NavigationHeader
        onGoBack={() => navigate(generateTicketRouteByViewType(props.data.viewType.id))}
      >
        <Body1 bold>{props.data.number}</Body1>
        {data.client && (
          <CompanyTag id={data.client.tickmillCompany.id}>
            {data.client.tickmillCompany.name}
          </CompanyTag>
        )}
      </NavigationHeader>

      <Tabs value={props.tab} onValueChange={tabNavigate} className='mt-2'>
        <TabsList>
          <TabsTrigger value={TicketTab.DETAILS}>Details</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
